import lozad from "lozad";

document.addEventListener("DOMContentLoaded", function () {
  const observer = lozad(".js-lazy", {
    rootMargin: "200% 400%",
  });
  observer.observe();
});
